import { render, staticRenderFns } from "./ManualUpdater.vue?vue&type=template&id=47941e62&"
import script from "./ManualUpdater.vue?vue&type=script&lang=js&"
export * from "./ManualUpdater.vue?vue&type=script&lang=js&"
import style0 from "./ManualUpdater.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports